import { ShowSnackBar } from "event-definitions"

export function infoSnackbar(message, options = {}) {
    ShowSnackBar.raiseLater(message, { variant: "info", ...options })
}
